module.exports = __webpack_public_path__ + "media/images/tundra_32x32-f20abbb93a4fc44c22799de6e06990ab.png";